import { render, staticRenderFns } from "./paidRecordDetail.vue?vue&type=template&id=0cf51ca8&scoped=true"
import script from "./paidRecordDetail.vue?vue&type=script&lang=js"
export * from "./paidRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./paidRecordDetail.vue?vue&type=style&index=0&id=0cf51ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf51ca8",
  null
  
)

export default component.exports